export default {
  title: 'Bienvenido',
  description: 'Ahora puedes realizar tu compra',
  wifi_alert: 'Debes contar con una conexión WIFI o datos móviles de navegación para este módulo',
  msisdn_description: 'Introduce tu número'
}
